module.exports = __webpack_public_path__ + "img/friends_empty.e47b74ac.png";